import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { HttpBaseService } from '@service/http-base.service';
import { AuthTokenHelper } from '@helpers/auth-token-helper';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingHelper } from '@helpers/routinghelper';
import { FormControl, Validators, FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
import { PatientProblemService } from '@service/patient-facesheet/patient-problem.service';
import { PatientProblem, PatientProblemMaster, PatientFaceSheetViewModel } from '@models/patient-facesheet/patient-problem.model';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-problems-dialog',
  templateUrl: './problems-dialog.component.html',
  styleUrls: ['./problems-dialog.component.sass']
})
export class ProblemsDialogComponent extends ValueAccessorHelper<any> implements OnInit {
  @Input() patientId: number;
  @Input() apiURL: string;
  @Input() masters: any;
  action: string;
  dialogTitle: string;
  patientProblemForm: FormGroup;
  index: number;
  patientProblem: PatientProblem;
  medicalCode: any;
  icdCode: string = 'ICD 10';
  icdCodes: any;
  dataItems: any[] | null;
  //apiURL: string;
  @ViewChild(MatSelect) matSelect: MatSelect;

  constructor(
    public dialogRef: MatDialogRef<ProblemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private routingHelper: RoutingHelper,
    private httpService: HttpBaseService,
    private patientProblemService: PatientProblemService,
    private authHelper?: AuthTokenHelper,
    private helper?: BeyondEMRHelper,
    private datePipe?: DatePipe
  ) {
    super();
    // Set the defaults
    this.action = data.action;
    this.masters = data.masters;
    this.dataItems = data.dataItems;
    let id = this.routingHelper.GetRoutingParamerterId(this.route.params);
    this.bindMasters(id);
    if (this.action === 'edit') {
      this.dialogTitle = 'Edit Diagnosis' ;
      this.patientProblem = data.patientItem;
      this.icdCode = this.filterByMaster(this.patientProblem.MedicalCodeId, this.masters);
      
    } else {
      this.dialogTitle = 'Add Diagnosis';
      this.patientProblem = data.patientItem;     
      this.patientProblem = new PatientProblem();
      this.patientProblem.PatientId = data.patientId;
    }    
    this.getICDCodes();
    this.onChangeICDType();
    this.patientProblemForm = this.createForm();
  }

  formControl = new FormControl('', [
    Validators.required
  ]);

  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'Required field'
      : this.formControl.hasError('email')
        ? 'Not a valid email'
        : '';
  }

  createForm(): FormGroup {
    return this.fb.group({
      Id: [this.patientProblem.Id],
      Code: [this.patientProblem.Code],      
      FromDate: [this.patientProblem.FromDate],
      Active: [this.patientProblem.DisplayInList],
    });
  }

  ngOnInit() {
    this.patientId = this.routingHelper.GetRoutingParamerterId(this.route.params);
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;     
    });
  }

 

  onSubmit(formElement: NgForm) {
    this.patientProblem.FromDate = this.datePipe.transform(this.patientProblem.FromDate, "MM/dd/yyyy");
    if (this.action == 'add') {
      const matchingItem = this.dataItems.find(item => item.MedicalCodeId === this.patientProblem.MedicalCodeId);
      if (matchingItem) {
        this.dialogRef.close();
        return;
      }
    }
    if (this.patientProblem.Id > 0) {
      this.patientProblemService.updatePatientProblem(this.patientProblem);
    }
    else {
      this.patientProblemService.addPatientProblem(this.patientProblem);
    }
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  filterByMaster(id, master): any {
    if (id > 0) {
      var result = master?.find(x => x.Id == id);
      return result ? result['ICDType'] : '';
    }
  }

  getICDCodes() {
    this.icdCodes = new Set(this.masters.map(x => x.ICDType));
  }

  onChangeICDType() {
    this.medicalCode = this.masters.filter(x => x.ICDType == this.icdCode);   
  }

  //auto populate sections need to made as generic component
  onChangeDiagnosisCode(item) {
    this.patientProblem.Code = this.helper.filterByMaster(this.patientProblem.MedicalCodeId, this.masters,'Code');
    this.patientProblem.Description = this.helper.filterByMaster(this.patientProblem.MedicalCodeId, this.masters,'DisplayName');
  }

  bindMasters(id) {
    let isCreate = id > 0 ? false : true;
    this.masters = this.helper.bindMaster(this.masters, isCreate, this.patientProblem?.MedicalCodeId);
  }

  ngAfterViewInit() {
    this.matSelect.openedChange.subscribe(opened => {
      if (opened) {
        this.matSelect.panel.nativeElement.addEventListener('mouseleave', () => {
          this.matSelect.close();
        })
      }
    })

  }
}
